const jumplink = document.querySelectorAll('[data-behaviour="jumplink"]');

if (jumplink.length > 0) {

    const jumpLinkEvent = new CustomEvent('jumpLinkEvent');

    jumplink.forEach((link) => {

        link.addEventListener('click', (ev) => {
            ev.preventDefault();

            const href = ev.target.getAttribute("href");
            const target = document.querySelector(href);
            let offset = (target.getBoundingClientRect().top + document.documentElement.scrollTop);
            const subnav = document.querySelector('[data-behaviour="subnav"]');

            if(subnav) {
                offset = target.offsetTop - subnav.clientHeight;
            } else {
                offset = offset - 50;
            }

            if( offset ) {
                
                window.scrollTo({
                    behavior: "smooth",
                    top: offset
                });

                document.dispatchEvent(jumpLinkEvent);
                
            }

        });

    });

}